import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {
  AccountingAccount,
  AccountingConnection
} from '../../../../../../../../models/organization-config';
import { OrganizationConfigService } from '../../../../../../../../services/organization-config/organization-config.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../utils';
import { AccountingSoftwareType } from '../../../../../../../../models/organization-config-enums';


@Component({
  selector: 'app-set-payment-processor-fee-account-modal',
  templateUrl: './set-payment-processor-fee-account-modal.component.html',
  styleUrls: ['./set-payment-processor-fee-account-modal.component.css']
})
export class SetPaymentProcessorFeeAccountModalComponent implements OnInit {
  @Input() conn: AccountingConnection;
  @Input() currentAccountId: string;
  @Input() currentAccountCode: string;
  @Input() currentAccountName: string;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public accounts: AccountingAccount[];
  public selectedAccount: AccountingAccount = null;

  public loadingAccounts = true;
  public loadingSave = false;

  public serverError: number = null;

  public AccountingSoftwareType = AccountingSoftwareType

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {
  }

  ngOnInit() {
    if (this.conn.accounting_software === AccountingSoftwareType.none) {
      this.selectedAccount = {
        account_id: this.currentAccountId,
        account_code: this.currentAccountCode,
        account_name: this.currentAccountName,
        account_type: ''
      }
    } else {
      this.loadAccounts();
    }
  }

  public handleSubmit() {
    if (this.selectedAccount === null) { return; }

    this.loadingSave = true;

    this.orgConfigService
      .setPaymentProcessorFeeAccount(
        this.conn.id,
        this.selectedAccount
      )
      .then(() => {
        this.savedCallback({
          text: 'Payment processor fee account updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingSave = false; });
  }

  private loadAccounts() {
    this.loadingAccounts = true;

    this.orgConfigService
      .getAllAccounts(this.conn.id)
      .then(response => {
        this.accounts = response;

        for (const account of this.accounts) {
          if (account.account_id === this.currentAccountId) {
            this.selectedAccount = account;
          }
        }
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingAccounts = false; });
  }

}
